<div class="flex flex-col gap-6">
  <ul role="list" class="grid grid-cols-1 gap-3 sm:grid-cols-2">
    @for (option of provisionOptions; track option.id) {
    <li>
      <button type="button" (click)="selectProvision(option.id)"
        [attr.aria-pressed]="createMonitoringService.provisionMode() === option.id"
        class="h-full w-full rounded-xl border p-4 text-left transition-colors"
        [class]="createMonitoringService.provisionMode() === option.id ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card hover:border-foreground/30'">
        <p class="font-heading text-base font-bold">{{ option.name }}</p>
        <p class="mt-1 text-sm text-muted-foreground">{{ option.description }}</p>
      </button>
    </li>
    }
  </ul>

  @if (createMonitoringService.provisionMode() === 'upload') {
  <div class="flex flex-col gap-2">
    <h3 class="font-heading text-base font-bold">Upload brief document</h3>
    <p class="text-sm text-muted-foreground">The file link is sent with the brief as the source document.</p>
    <atom-add-document (documentUploaded)="onDocumentUploaded($event)"></atom-add-document>
    @if (createMonitoringService.requirementsDocumentUrl()) {
    <p class="text-xs text-muted-foreground">Document attached.</p>
    }
  </div>
  } @else {
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <h3 class="font-heading text-base font-bold">Requirements</h3>
      <p class="text-sm text-muted-foreground">What matching content must show.</p>
      <atom-wysiswyg [inputHtml]="createMonitoringService.requirementsHtml()" placeholder="What content must show"
        (htmlContentChange)="onRequirements($event)"></atom-wysiswyg>
    </div>
    <div class="flex flex-col gap-2">
      <h3 class="font-heading text-base font-bold">Not allowed</h3>
      <p class="text-sm text-muted-foreground">Content that should be flagged.</p>
      <atom-wysiswyg [inputHtml]="createMonitoringService.restrictionsHtml()" placeholder="What is not allowed"
        (htmlContentChange)="onDonts($event)"></atom-wysiswyg>
    </div>
  </div>
  }

  @if (complianceDocs().length) {
  <div class="flex flex-col gap-3">
    <div>
      <h3 class="font-heading text-base font-bold">Compliance library</h3>
      <p class="mt-1 text-sm text-muted-foreground">We check monitored content against the documents you select.</p>
    </div>
    <ul role="list" class="flex flex-col gap-2">
      @for (doc of complianceDocs(); track doc.id) {
      <li>
        <button type="button" (click)="toggleCompliance(doc.id)" [attr.aria-pressed]="isComplianceSelected(doc.id)"
          class="w-full rounded-lg border p-3.5 text-left transition-colors"
          [class]="isComplianceSelected(doc.id) ? 'border-brand-studio bg-brand-studio/10' : 'border-border bg-card hover:border-foreground/30'">
          <p class="text-sm font-semibold text-foreground">{{ doc.complianceName }}</p>
          @if (doc.description) {
          <p class="mt-1 truncate text-xs text-muted-foreground">{{ doc.description }}</p>
          }
        </button>
      </li>
      }
    </ul>
  </div>
  }
</div>
